import React, { useState } from 'react';
import { sendMessage } from '../api/api'; // Step 2: Call this API
import { PiWhatsappLogoFill } from "react-icons/pi";

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setSubmitted(false);

  try {
    await sendMessage(formData); // send to backend
    setSubmitted(true);
    alert('Your message has been sent successfully!');
    setFormData({ name: '', email: '', subject: '', message: '' });
  } catch (err) {
    console.error(err);
    setError('Something went wrong. Please try again.');
    alert('Failed to send message.');
  }
};


  return (
    <>
      <section id="contact" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Contact</h2>
          <p>Contact Us For More Information</p>
        </div>

        <div className="container" data-aos="fade" data-aos-delay={100}>
          <div className="row gy-4">
            <div className="col-lg-4">
             <div className="info-item d-flex" data-aos="fade-up" data-aos-delay={200}>
              <i className="bi bi-geo-alt flex-shrink-0" />
              <div>
                <h3>Head Office</h3>
                <p>King Road Tower, 2nd Floor, Office 1207<br />Malik Road, Jeddah, Kingdom of Saudi Arabia</p>
              </div>
            </div>

              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay={300}>
                  <i className="bi bi-telephone flex-shrink-0" />
                  <div>
                      <h3>Call Us</h3>
                      <p>
                        <a href="tel:0546040748" style={{ textDecoration: 'none', color: '#000' }}>
                          Phone: 054 604 0748
                        </a>
                        <br />

                        <a href="https://wa.me/966556502044" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000' }}>
                          <span style={{ color: '#25D366', fontSize: '20px', marginRight: '6px' }}>
                            <PiWhatsappLogoFill />
                          </span>
                          (Jeddah): 055 650 2044
                        </a>
                        <br />

                        <a href="https://wa.me/966556501214" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000' }}>
                          <span style={{ color: '#25D366', fontSize: '20px', marginRight: '6px' }}>
                            <PiWhatsappLogoFill />
                          </span>
                          (Bahrah): 055 650 1214
                        </a>
                        <br />

                        <a href="https://wa.me/966556502989" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#000' }}>
                          <span style={{ color: '#25D366', fontSize: '20px', marginRight: '6px' }}>
                            <PiWhatsappLogoFill />
                          </span>
                          (Makkah): 055 650 2989
                        </a>
                      </p>
                    </div>
                    </div>

             <div className="info-item d-flex" data-aos="fade-up" data-aos-delay={400}>
                <i className="bi bi-envelope flex-shrink-0" />
                <div>
                  <h3>Email Us</h3>
                  <p><a href="mailto:sales@mac-itsolution.com">sales@mac-itsolution.com</a></p>

                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <form onSubmit={handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay={200}>
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-12">
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-12">
                    <textarea
                      className="form-control"
                      name="message"
                      rows={6}
                      placeholder="Message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    {submitted && <div className="sent-message">Your message has been sent. Thank you!</div>}
                    {error && <div className="error-message">{error}</div>}
                    <button type="submit">Send Message</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
